module.exports = __webpack_public_path__ + "img/[笑脸].1eec9064.svg";